/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TabsComponent} from './tabs.component';
import {TooltipModule} from '../tooltip/tooltip.module';

@NgModule({
    declarations: [TabsComponent],
    imports: [
        CommonModule,
        TooltipModule
    ],
    exports: [TabsComponent]
})
export class TabsModule {
}
